import React, { useMemo } from 'react';
import styled from 'styled-components/macro';

import { viewport } from '../../../../common/config';
import Container from '../Container';
import { getVh } from '../utils';

const Flower = styled.img`
  aspect-ratio: 270/259;
  height: 80vh;
  width: auto;

  transform: translate(50vw, -50%);

  @media screen and (min-width: ${viewport.md}) {
    transform: translate(-100%, -50%) translate(30vw);
  }
`;

const AutumnFlower = () => {
  const top = useMemo(() => getVh("faqs", 0.5), []);

  return (
    <Container
      top={top}
      style={{ left: "0", transform: "translateY(0)", opacity: 1 }}
    >
      <Flower src="/static/images/fill/autumn_flower.png" />
    </Container>
  );
}

export default AutumnFlower;